import { ErrorHandler, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from '@shared/shared.module';

import { AuthService } from './auth/auth.service';
import { AuthGuardService } from './auth/auth-guard.service';
import { ClientGuardService} from './auth/client-guard-service';
import { UserGuardService } from './auth/user-guard-service';
import { AccountGuardService } from './auth/account-guard-service';
import { AppMonitoringService } from './services/app-monitoring.service';
import { StorageService } from './services/storage.service';
import { GlobalErrorHandler } from './handlers/global-error.handler';
import { MONITORING_AGENT } from './injection-tokens';
import { EventBusService } from './services/event-bus.service';

declare global {
  interface Window { newrelic: any; }
}

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    RouterModule,
    TranslateModule,
    SharedModule
  ],
  providers: [
    StorageService,
    AuthService,
    AuthGuardService,
    ClientGuardService,
    UserGuardService,
    AccountGuardService,
    AppMonitoringService,
    EventBusService,
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: MONITORING_AGENT, useValue: window.newrelic },
  ]
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
      parentModule: CoreModule,
  ) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import only in AppModule');
    }
  }
}
